import { Reveal } from "@/components/Reveal";
import { Check } from "lucide-react";

const REASONS = [
  { title: "RCI-registered", text: "Full compliance with Rehabilitation Council of India guidelines — Reg. No. A58697." },
  { title: "In-school delivery", text: "Therapy happens inside your school. No travel for parents, no lost class time." },
  { title: "Team model", text: "A coordinator, an assessor, and a therapist — not a single overstretched visitor." },
  { title: "Data protection", text: "Secure records and written parent consent for every child, every step." },
  { title: "Flexible", text: "We fit your timetable and your budget — programmes shaped to each school." },
];

export const Manifesto = () => (
  <section id="why-us" className="border-y border-pine-900/10 bg-pine-950 py-24 text-cream lg:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <Reveal className="lg:col-span-7">
        <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.28em] text-honey">Why schools choose us</p>
        <h2 className="font-serif text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl">
          Built for schools, not adapted to them.
        </h2>
        <ul className="mt-12 space-y-7" data-testid="why-us-list">
          {REASONS.map((r) => (
            <li key={r.title} className="flex items-start gap-4 border-b border-cream/10 pb-7 last:border-0">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-honey text-pine-950">
                <Check size={14} strokeWidth={3} />
              </span>
              <div>
                <p className="font-serif text-lg font-semibold sm:text-xl">{r.title}</p>
                <p className="mt-1 max-w-lg text-sm leading-relaxed text-cream/65">{r.text}</p>
              </div>
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal className="lg:col-span-5" delay={0.15}>
        <div className="flex h-full flex-col justify-between rounded-3xl border border-cream/10 bg-pine-900/60 p-10">
          <img src="/assets/bee.jpg" alt="" className="h-20 w-20 rounded-full bg-white object-contain p-1.5" />
          <p className="mt-10 font-serif text-3xl font-semibold italic leading-snug sm:text-4xl" data-testid="why-us-tagline">
            Small steps.<br />Big progress.
          </p>
          <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-cream/50">
            Supporting communication.<br />Building brighter futures.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
